// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NyX8e","header__wrapper":"styles_header__wrapper__umCE5","header__logo":"styles_header__logo__MPyk5"};